module.exports = __webpack_public_path__ + "img/1759860838585.82cf277d.jpeg";